// Utility function to generate action option test-ids
export const getActionOptionTestId = (actionId, optionId, type) => {
  return `ACTION_${actionId}_OPTION_${optionId}_${type}`;
};

// Utility function to generate actor test-ids
export const getActorTestId = (actorId, type) => {
  return `ACTOR_${actorId}_${type}`;
};

// Utility function to generate metric test-ids
export const getMetricTestId = (metricId, type) => {
  return `METRIC_${metricId}_${type}`;
};
